import { SessionStorageKey } from '../enums/session-storage-key.enum';
import { DecoratorUtil } from '../utils/decorator.util';

export function InjectSessionStorage(storageKey: SessionStorageKey, options?: { separator: string }): PropertyDecorator {
	return (target: any, propertyKey: string) => {

		Object.defineProperty(target, propertyKey, {
			set: value => {
				if (value === null) {
					sessionStorage.removeItem(storageKey);
				} else {
					sessionStorage.setItem(storageKey, String(value));
				}
			},
			get: () => {
				const value = sessionStorage.getItem(storageKey);
				return DecoratorUtil.convertValueToType(target, propertyKey, value, options);
			},
			enumerable: true,
			configurable: true
		});
	};
}
